<template>
  <div>
    <ImageInput v-model="image" suggest="alphabet" :aspect-ratio="1"></ImageInput>
  </div>
</template>

<script>
import ImageInput from './ImageInput'
import { SOURCE_DICTIONARY_UPDATE } from '../store/action-types'

export default {
  components: { ImageInput },
  computed: {
    image: {
      get () {
        return this.$store.state.sourceDictionary.alphabetImage
      },
      async set (val) {
        const sourceDictionary = { ...this.$store.state.sourceDictionary, alphabetImage: val }
        await this.$store.dispatch(SOURCE_DICTIONARY_UPDATE, { sourceDictionary })
      }
    }
  }
}
</script>
